var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCopy({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0h-6c-1.058 0-2 .97-2 2l-.578.014C1.864 2.014 1 2.97 1 4v10c0 1.03.942 2 2 2h7.5c1.058 0 2-.97 2-2h.5c1.058 0 2-.97 2-2V4.012L11.5 0zm-1 15H3c-.525 0-1-.491-1-1V4a1 1 0 011-.983L3.5 3v9c0 1.03.942 2 2 2h6c0 .509-.475 1-1 1zm3.5-3c0 .509-.475 1-1 1H5.5c-.525 0-1-.491-1-1V2c0-.509.475-1 1-1h5c-.008 1.151 0 2.013 0 2.013 0 1.038.935 1.987 2 1.987H14v7zm-1.5-8c-.533 0-1-.967-1-1.486v-1.5L14 4h-1.5zm-1 3.009c-4.5 0-4.5.523-4.5.5 0 .4.324.499.5.499h4a.5.5 0 000-.999zm0 2.498H7a.5.5 0 000 .998h4.5a.5.5 0 100-.998z"
  })));
}

export default SvgCopy;